var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1778.9 -88.088)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1779 88.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.767,5A14.767,14.767,0,1,0,34.534,19.767,14.778,14.778,0,0,0,19.767,5Zm0,1.342A13.425,13.425,0,1,1,6.342,19.767,13.414,13.414,0,0,1,19.767,6.342Zm0,3.356a4.686,4.686,0,0,0-2.735,8.5,8.735,8.735,0,0,0-5.991,8.28.671.671,0,1,0,1.342,0,7.384,7.384,0,1,1,14.767,0,.671.671,0,1,0,1.342,0A8.735,8.735,0,0,0,22.5,18.2a4.686,4.686,0,0,0-2.735-8.5Zm0,1.342A3.356,3.356,0,1,1,16.411,14.4,3.345,3.345,0,0,1,19.767,11.041Z",
    transform: "translate(-5 -5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.af2cdf4e619952e64b0149c116991cb3.svg";
export { ForwardRef as ReactComponent };